<!-- src/components/LoginForm.vue -->
<template>
<div>
  <div class="form-container">
  <div class="login-form">
    <h2>404 Not Found</h2>

    <div class="top-text"><p>We couldn't find the page you were looking for..</p></div>   

    <button class="submit-button" @click="homeNavigation" type="submit">Return to Homepage</button>

  </div>
  </div>
</div>
</template>

<script>


export default {


  data() {
    return {
      email: '',
      messa:false
    };
  },
  methods: {

    homeNavigation(){
      this.$router.push('/');

    },
   
  }

};

</script>


<style scoped>
.login-form {
  display: flex;
  flex-direction: column;
  width: 400px;
  /* margin: 2% auto 0; */
  margin: auto 0;
  gap: 5%;
  border: 1px solid grey;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background: #1a1625;
  align-items: center;
  justify-content: center;
}

.form-container{
  height:100vh;
  width:100vw;
  /* border-top:30px solid transparent; */
  display: flex;
  justify-content: center;
  background: #2f2b3a ;
}


h2 {
  text-align: center;
  color: peachpuff;
}



p{
  text-align: center;
  color:whitesmoke;
  font-size: 15px;
}



.submit-button {
  width: 80%;
  padding: 10px;
  margin-top:8px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
}





.submit-button{
  width:50%;
  background-color: #ffff99;
  color: #001233;
  border: 1px solid #8f9ba3;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}


.submit-button:hover {
  background-color: #d5d58b;
}



.logo {
  width: 70px;
  height: 70px;
  cursor: pointer;
  border-radius: 50%;
}

.hyper-link{
  color:cyan;
}


.top-text{
  width:86%;
  margin-bottom:10%;
}

</style>
